"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningIcon = exports.WarningLabel = void 0;
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("@tableau/widgets/lib/gen-src/Localize");
var react_1 = __importDefault(require("react"));
var Localize_2 = require("../../../../gen-src/Localize");
var icons_1 = require("../../../../gen-src/icons");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
var LabelPopover_1 = require("../LabelPopover");
var Styles_1 = require("../Styles");
var LabelType_1 = require("../shared/LabelType");
var useControlledPopover_1 = require("../shared/useControlledPopover");
function warningLabelTitle(props) {
    switch (props.kind) {
        case 'dehydrated': return Localize_2.Messages.DataQualityTypeWarning();
        case 'hydrated':
            return warningLabelTitleCalculation(props);
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props);
            return '';
    }
}
function warningLabelTitleCalculation(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    var count = ((_b = (_a = props.anchored) === null || _a === void 0 ? void 0 : _a.labels.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = props.upstream) === null || _c === void 0 ? void 0 : _c.labels.length) !== null && _d !== void 0 ? _d : 0) + ((_f = (_e = props.parented) === null || _e === void 0 ? void 0 : _e.labels.length) !== null && _f !== void 0 ? _f : 0);
    if (count <= 0) {
        return '';
    }
    if (count === 1) {
        if (((_g = props.anchored) === null || _g === void 0 ? void 0 : _g.labels.length) === 1) {
            return (0, LabelType_1.localizeLabelTypeName)((_h = props.anchored) === null || _h === void 0 ? void 0 : _h.labels[0].type);
        }
    }
    return Localize_2.Messages.DataQualityIconMessage({
        MESSAGE_COUNT: count,
        MESSAGE_COUNT_LOC: Localize_1.Formatters.formatCount(count),
    });
}
function warningIsSevere(props) {
    var _a, _b, _c, _d;
    if (!props) {
        return false;
    }
    switch (props === null || props === void 0 ? void 0 : props.kind) {
        case 'hydrated':
            if (((_a = props.anchored) === null || _a === void 0 ? void 0 : _a.labels.some(function (w) { return w.severe; })) || ((_b = props.parented) === null || _b === void 0 ? void 0 : _b.labels.some(function (w) { return w.severe; }))) {
                return true;
            }
            break;
        case 'dehydrated':
            return props.severe;
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(props);
    }
    return (_d = (_c = props === null || props === void 0 ? void 0 : props.upstream) === null || _c === void 0 ? void 0 : _c.labels.some(function (w) { return w.severe; })) !== null && _d !== void 0 ? _d : false;
}
function WarningLabel(props) {
    var _a, _b;
    var popover = (0, useControlledPopover_1.useControlledPopover)({
        testId: props.testId,
        popoverProps: {
            title: warningLabelTitle(props),
        },
        content: LabelPopover_1.LabelPopover,
        controlKind: (_b = (_a = props.controls) === null || _a === void 0 ? void 0 : _a.kind) !== null && _b !== void 0 ? _b : 'icon',
        iconProps: warningIconProps,
        chipProps: warningChipProps,
        onClick: props.onClick,
        loading: props.loading,
        props: __assign({}, props)
    });
    return popover !== null && popover !== void 0 ? popover : react_1.default.createElement(react_1.default.Fragment, null);
}
exports.WarningLabel = WarningLabel;
function warningChipProps(props) {
    return {
        type: warningIsSevere(props) ? widgets_1.InlineAlertType.Warning : widgets_1.InlineAlertType.Info,
        iconContainerStyle: { display: 'inline-flex' },
        kind: 'inline-alert-props'
    };
}
function warningIconProps(props) {
    return {
        getContent: props ? function (s) { return react_1.default.createElement(WarningIcon, { hover: s.hover, isSevere: function () { return warningIsSevere(props); } }); } : undefined,
        style: {
            padding: widgets_1.TabStyles.Spacing.SmallSpace,
            cursor: 'pointer',
        },
        buttonType: widgets_1.ButtonType.Icon,
        kind: 'button-props',
    };
}
function WarningIcon(props) {
    var severe = props.isSevere();
    if (props.hover) {
        return severe ?
            react_1.default.createElement(icons_1.SvgWarningHighSeverityActive, { className: Styles_1.LabelIconClass }) :
            react_1.default.createElement(icons_1.SvgSpacesDataStatusActive, { className: Styles_1.LabelIconClass });
    }
    else {
        return severe ?
            react_1.default.createElement(icons_1.SvgWarningHighSeverity, { className: Styles_1.LabelIconClass }) :
            react_1.default.createElement(icons_1.SvgSpacesDataStatus, { className: Styles_1.LabelIconClass });
    }
}
exports.WarningIcon = WarningIcon;
//# sourceMappingURL=WarningButton.js.map